import { Form } from 'formik';
import React, { FC, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { stepInfoFulfilled } from '../../../../../actions/registerShipmentActions';
import useScrollToFirstFormikError from '../../../../../hooks/useScrollToFIrstFormikError';
import IPageViewModel from '../../../../../interfaces/umbracoNodes/pageViewModel';
import Button from '../../../../base/button';
import { IStepOptionalServicesFormInfo } from '../../stepOptionalServices/stepOptionalServices.schema';
import { requiresBusinessAccountForCompanySender } from '../helpers';
import { IStepInfoFormInfo } from '../stepInfo.schema';
import ReceiverFields from './receiverFields/receiverFields';
import SenderFields from './senderFields/senderFields';
// import { Column } from '../../../../base/grid';
import * as StyledStepInfoForm from './stepInfoForm.styles';

interface Props {
	values: IStepInfoFormInfo;
	setFieldTouched: any;
	setFieldValue: any;
	validateForm: any;
	isValid: boolean;
	isSubmitting: boolean;
	onPrevious: any;
	errors: any;
	goingToPostbox: boolean;
	page: IPageViewModel;
}

const StepInfoForm: FC<Props> = ({
	values,
	setFieldTouched,
	setFieldValue,
	isValid,
	isSubmitting,
	errors,
	goingToPostbox,
	page,
	validateForm,
}) => {
	const dispatch = useDispatch<any>();
	const { t } = useTranslation('registerShipment');
	const { stepOptionalServicesFormInfo }: { stepOptionalServicesFormInfo: IStepOptionalServicesFormInfo } =
		useSelector(
			(state: { registerShipmentReducer: { stepOptionalServicesFormInfo: IStepOptionalServicesFormInfo } }) =>
				state.registerShipmentReducer
		);
	const ref = useRef(null);
	useScrollToFirstFormikError(errors, isSubmitting, isValid, ref);
	const blockBusinessAccountCountry = requiresBusinessAccountForCompanySender(values);

	// If we want to be able to store values when a client goes back in the number pad we can use this tecnique but
	// it will make it so that we will dispatch everythign twice for this step when going forward or back
	const getValues = useRef(values);
	useEffect(() => {
		getValues.current = values;
	});

	useEffect(() => {
		return () => {
			dispatch(stepInfoFulfilled(getValues.current));
		};
	}, [dispatch]);

	return (
		<div ref={ref}>
			<Form autoComplete="on">
				<StyledStepInfoForm.Wrapper>
					{/* <FormikFieldWrapper
						label={t('step-optional-services.who-pays')}
						name="payer"
						languageComponent="registerShipment"
						marginBottom="2rem">
						<FormikRadioWrapper>
							<FormikRadio
								id="sendandi"
								name="payer"
								label={t('shared.sender')}
								setFieldValue={setFieldValue}
							/>
							<FormikRadio
								id="vidtakandi"
								name="payer"
								disabled={!receiverCanPay}
								label={`${t('shared.recipient')} ${t('step-optional-services.price-for-recipient')}`}
								setFieldValue={setFieldValue}
							/>
						</FormikRadioWrapper>
					</FormikFieldWrapper> */}
					<SenderFields
						values={values}
						setFieldTouched={setFieldTouched}
						setFieldValue={setFieldValue}
						codIncluded={stepOptionalServicesFormInfo.optionalServices.includes('Cod')}
						page={page}
					/>
					<ReceiverFields
						values={values}
						setFieldTouched={setFieldTouched}
						setFieldValue={setFieldValue}
						goingToPostbox={goingToPostbox}
						validateForm={validateForm}
					/>
					<StyledStepInfoForm.ButtonWrapper>
						<Button wide primary type="submit" disabled={values.country.isClosed || blockBusinessAccountCountry}>
							{t('shared.next-step')}
						</Button>
					</StyledStepInfoForm.ButtonWrapper>
				</StyledStepInfoForm.Wrapper>
			</Form>
		</div>
	);
};

export default StepInfoForm;
